import {FINISHED} from './featureConstants';

export const selectIsFeatureEnabled = (state, name) =>
  !![
    state.feature.urlFeatures[name],
    state.feature.sessionFeatures[name],
    state.feature.switcherFeatures[name],
    state.feature.environmentFeatures[name],
  ].find(enabled => enabled !== undefined);

export const selectHasLoadedFeatures = state =>
  state.feature.status === FINISHED;
